import React from 'react';

const Card = ({ children, title }) => {
  return (
    // On enlève l'ombre et on met un fond de "surface" sombre
    <div className="bg-dark-surface rounded-lg p-6">
      {title && <h2 className="text-xl font-bold text-dark-text-primary mb-4">{title}</h2>}
      <div>
        {children}
      </div>
    </div>
  );
};

export default Card;